/**
 * @description This file contains web-only constants due to its dependency on svg based icon components which are not compatible with mobile. All joint mobile/web constants live in @modules/for-you/constants.ts
 */

import {
  RESOURCE_TOPIC_LABEL_NAMES,
  RESOURCE_ARTICLE_TOPIC_LABEL_NAMES,
  RESOURCE_FILTER_LABEL_NAMES,
  RESOURCE_ARTICLE_TOPIC_NAME,
} from "./types";

import {
  ComprehensiveWealth,
  CareerManagement,
  CashManagement,
  DebtManagement,
  InsurancePlan,
  TaxPlan,
  TrustAndEstatePlan,
  InvestmentPlan,
} from "@components/Icons";

import { FC, SVGProps } from "react";

const RESOURCE_TOPIC_ICON_MAP: Record<
  RESOURCE_ARTICLE_TOPIC_NAME,
  {
    label: RESOURCE_ARTICLE_TOPIC_LABEL_NAMES;
    IconComponent: FC<SVGProps<SVGSVGElement>>;
  }
> = {
  CAREER: {
    label: RESOURCE_TOPIC_LABEL_NAMES.CAREER_MANAGEMENT,
    IconComponent: CareerManagement,
  },
  ESTATE: {
    label: RESOURCE_TOPIC_LABEL_NAMES.TRUST_AND_ESTATE_PLANNING,
    IconComponent: TrustAndEstatePlan,
  },
  CASH: {
    label: RESOURCE_TOPIC_LABEL_NAMES.CASH_MANAGEMENT,
    IconComponent: CashManagement,
  },
  DEBT: {
    label: RESOURCE_TOPIC_LABEL_NAMES.DEBT_MANAGEMENT,
    IconComponent: DebtManagement,
  },
  INSURANCE: {
    label: RESOURCE_TOPIC_LABEL_NAMES.INSURANCE_PLANNING,
    IconComponent: InsurancePlan,
  },
  INVESTMENTS: {
    label: RESOURCE_TOPIC_LABEL_NAMES.INVESTMENT_MANAGEMENT,
    IconComponent: InvestmentPlan,
  },
  TAX: {
    label: RESOURCE_TOPIC_LABEL_NAMES.TAX_PLANNING,
    IconComponent: TaxPlan,
  },
  MULTIPLE: {
    label: RESOURCE_TOPIC_LABEL_NAMES.COMPREHENSIVE_WEALTH,
    IconComponent: ComprehensiveWealth,
  },
  // interactive tool Q2
};

const RESOURCE_FILTER_ICON_MAP: Record<
  RESOURCE_FILTER_LABEL_NAMES,
  FC<SVGProps<SVGSVGElement>>
> = {
  "All Financial Topics": ComprehensiveWealth,
  "Career Management": CareerManagement,
  "Cash Management": CashManagement,
  "Debt Management": DebtManagement,
  "Insurance Planning": InsurancePlan,
  "Investment Management": InvestmentPlan,
  "Tax Planning": TaxPlan,
  "Trust and Estate Planning": TrustAndEstatePlan,
};

export { RESOURCE_TOPIC_ICON_MAP, RESOURCE_FILTER_ICON_MAP };
